/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */

// You can delete this file if you're not using it
import React from "react";
import Transition from "./src/components/Transition";

export const wrapPageElement = ({ element, props }) => {
  return <Transition {...props}>{element}</Transition>;
};

//Needed for smooth page transition and timing. Else new page renders before fade out.
export const shouldUpdateScroll = () => false
export const onRouteUpdate = ({location}) =>
  window.setTimeout(() => {
    switch(location.hash){
      case '#whyus':
          document.getElementById('whyus').scrollIntoView();
          break
      case '#ourteam':
          document.getElementById('ourteam').scrollIntoView();
          break
      case '#clients':
          document.getElementById('clients').scrollIntoView();
          break
      case '#location':
          document.getElementById('location').scrollIntoView();
          break
      case '#message':
          document.getElementById('message').scrollIntoView();
          break
      default:
        window.scrollTo(0, 0)
    }
  }, 300)
